import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { map } from 'rxjs/operators';
import { Catalog } from '../interfaces/catalog';
import { CatalogItem } from '../interfaces/catalogItem';
import { City } from '../interfaces/city';
import { Endpoints } from '../resources/endpoints';
import { Global } from '../resources/global';
import { Utils } from '../resources/utils';
import { environment } from './../../../environments/environment'
import { BasicCity } from '../interfaces/basicCity';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CatalogService {

  constructor(
    private http: HttpClient,
    private endpoints: Endpoints
  ) { }

  public getCatalog(typeCatalog: string) {
    return this.http.get<Catalog>(
      environment.urlServerTeclogi + this.endpoints.urlCatalog + '/' + typeCatalog
    );
  }

  public getTransportCompanies(): Observable<CatalogItem[]> {
    return this.http.get<CatalogItem[] | Catalog>(
      environment.urlServerTeclogi + this.endpoints.transportCompanyCatalog
    ).pipe(
      map((response: CatalogItem[] | Catalog) => {
        if (Array.isArray(response)) return response;
        if (response && response.catalog && Array.isArray(response.catalog)) return response.catalog;
        return [];
      })
    );
  }

  /**
   * Billing products for Business Central (`GET catalog/BillingProducts`).
   * Standard headers are applied by the HTTP interceptor.
   */
  public getBillingProducts(): Observable<Catalog> {
    return this.http.get<Catalog>(
      `${environment.urlServerTeclogi}${this.endpoints.urlCatalog}/BillingProducts`
    );
  }

  public getCargoQueryableVariables(): Observable<CatalogItem[]> {
    return this.http.get<CatalogItem[]>(
      `${environment.urlServerTeclogi}${this.endpoints.cargoQueryableVariables}`
    );
  }

  public getBasicCityByName(name: string, pageKey: number, pageSize: number) {

    return this.http.get<BasicCity[]>(
      // tslint:disable-next-line: max-line-length
      environment.urlServerTeclogi + this.endpoints.urlCatalog + '/cities/basic?name=' + name + '&pageKey=' + pageKey + '&pageSize=' + pageSize
    );
  }

  public getBasicCityByMunicipalityCode(municipalityCode: string, pageKey: number, pageSize: number) {
    return this.http.get<BasicCity[]>(
      // tslint:disable-next-line: max-line-length
      environment.urlServerTeclogi + this.endpoints.urlCatalog + '/cities/basic?id=' + municipalityCode + '&pageKey=' + pageKey + '&pageSize=' + pageSize
    );
  }

  public getCityByName(name: string, pageKey: number, pageSize: number, transportNit?: string) {

    return this.http.get<City[]>(
      // tslint:disable-next-line: max-line-length
      environment.urlServerTeclogi + this.endpoints.urlCatalog + '/cities?name=' + name + '&pageKey=' + pageKey + '&pageSize=' + pageSize + (transportNit ? '&transportCompanyId=' + transportNit : '')
    );
  }

  public getCityByMunicipalityCode(municipalityCode: string, pageKey: number, pageSize: number, transportNit?: string) {
    return this.http.get<City[]>(
      // tslint:disable-next-line: max-line-length
      environment.urlServerTeclogi + this.endpoints.urlCatalog + '/cities?id=' + municipalityCode + '&pageKey=' + pageKey + '&pageSize=' + pageSize + (transportNit ? '&transportCompanyId=' + transportNit : '')
    );
  }

}
